import { useState } from "react";
import { Card, CardContent, Typography, Box, Chip } from "@mui/material";
import PropTypes from "prop-types";
import CreateRequestDialog from "./CreateRequestDialog";

const Ticket = ({ request }) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "created":
        return "primary";
      case "in-progress":
        return "warning";
      case "completed":
        return "success";
      case "cancelled":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <>
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          boxShadow: 2,
          cursor: "pointer",
          "&:hover": {
            boxShadow: 4,
            transform: "translateY(-2px)",
            transition: "all 0.2s ease-in-out",
          },
        }}
        onClick={() => setIsDetailsOpen(true)}
      >
        <CardContent sx={{ flexGrow: 1 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 2,
            }}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontSize: "1rem",
                fontWeight: "bold",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {request.title}
            </Typography>
            <Chip
              label={request.status}
              color={getStatusColor(request.status)}
              size="small"
              sx={{ ml: 1 }}
            />
          </Box>
          <Typography
            color="text.secondary"
            gutterBottom
            sx={{ fontSize: "0.875rem" }}
          >
            Request ID: {request.id}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
            }}
          >
            {request.description}
          </Typography>
        </CardContent>
      </Card>

      <CreateRequestDialog
        open={isDetailsOpen}
        onClose={() => setIsDetailsOpen(false)}
        mode="view"
        request={request}
      />
    </>
  );
};

Ticket.propTypes = {
  request: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default Ticket;
